// @greenlight-spec: decisions/0026-integration-catalog-and-connection-profiles.md
// @greenlight-spec: 09-data-brokering.md
// @greenlight-spec: 15-database-schema.md#integrations
import { isInjectableConnectedDbAuthMode, } from '../types/integration.js';
/** Closed set of per-placeholder URL transforms. Undeclared tokens are trimmed only. */
export const PLACEHOLDER_NORMALIZES = ['lowercase_hyphenate', 'salesforce_my_domain'];
/** Optional constraint on a collected placeholder value. */
export const PLACEHOLDER_FORMATS = ['digits', 'uuid', 'salesforce_my_domain'];
/** The values a setup statement template may name. */
export const SETUP_STATEMENT_TOKENS = ['redirect_uri', 'security_integration'];
/** Fallback profile picker / Auth-mode row labels, keyed by mechanism. */
export const AUTH_MODE_DISPLAY_NAMES = {
    service_account: 'Service account (static key)',
    client_credentials: 'OAuth 2 client credentials',
    user_delegated: 'User passthrough',
    workload_identity: 'Workload identity (passwordless)',
    sql_password: 'SQL authentication (username + password)',
    service_principal: 'Service principal (Entra app in the DB’s tenant)',
    system: 'Platform-served (no credential)',
};
export function connectionProfileDisplayName(profile) {
    return profile.displayName ?? AUTH_MODE_DISPLAY_NAMES[profile.authMode];
}
/** True when every profile of the entry is platform-served (`system`, ADR-0036). */
export function isSystemEntry(entry) {
    return (entry.connectionProfiles.length > 0 &&
        entry.connectionProfiles.every((p) => p.authMode === 'system'));
}
// The delivery modes a catalog entry offers (ADR-0026 §5, ADR-0030). A connected
// database is proxied (the data proxy runs its queries), and also offers
// injected when one of its profiles can be delivered to a native driver (a
// service principal; the registration form narrows by the chosen profile). A
// system entry is always proxied (the control plane serves it — there is no
// credential to inject, ADR-0036); a proxyable HTTP entry offers both; a
// non-proxyable one offers only injected. Derived, never stored.
export function deliveryModesForEntry(entry) {
    if (entry.engine !== undefined) {
        return entry.connectionProfiles.some((p) => isInjectableConnectedDbAuthMode(p.authMode))
            ? ['proxied', 'injected']
            : ['proxied'];
    }
    if (isSystemEntry(entry))
        return ['proxied'];
    return entry.proxyable ? ['proxied', 'injected'] : ['injected'];
}
//# sourceMappingURL=types.js.map